export default function ProductFeature() {
  return (
    <section className="py-16 sm:py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
          {/* Image */}
          <div className="relative h-[380px] sm:h-[500px] md:h-[560px] overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/91412a7256747cd920ca01a168c5ad98.jpg"
              alt="Keratin & Hair Treatment - Blue Moon Beauty Salon Muscat"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
            <div className="absolute top-4 right-4 bg-[#1a2744] text-white px-4 py-2 text-xs tracking-widest uppercase font-light">
              NEW
            </div>
          </div>

          {/* Text */}
          <div>
            <p className="text-[#4a7fa5] text-xs tracking-[0.4em] uppercase mb-4 font-light">
              Exclusive Treatment / <span style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>علاج حصري</span>
            </p>
            <h2
              className="text-[#1a2744] text-3xl sm:text-4xl font-light tracking-wide mb-2 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Luxury{" "}
              <span className="italic text-[#c6a864]">Keratin &amp; Hair Spa</span>
            </h2>
            <p
              className="text-[#1a2744] text-xl font-bold mb-1"
              style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
            >
              علاج الكيراتين وسبا الشعر الفاخر
            </p>
            <p
              className="text-[#1a2744]/60 text-sm mb-5 text-right"
              style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
            >
              الأفضل في الخوض، مسقط — مخصص لمناخ عمان
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-3">
              Revitalize and enrich your hair with our exclusive Keratin &amp; Hair Spa
              treatment. Specially formulated for the Omani climate, this luxurious treatment
              fights humidity and restores silky smooth, frizz-free hair for months.
            </p>
            <p
              className="text-gray-400 text-sm leading-relaxed mb-3 text-right"
              style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
            >
              جددي حيوية شعرك مع علاج الكيراتين وسبا الشعر الحصري. مُركَّب خصيصاً لمناخ عمان، يحارب التجعد ويُعيد الملمس الحريري لشعرك لأشهر عديدة.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-3">
              Trusted by women across Muscat and Al Koudh — our specialists customize
              every treatment to your hair type and lifestyle.
            </p>
            <p
              className="text-gray-400 text-sm leading-relaxed mb-8 text-right"
              style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
            >
              موثوق به من قِبل نساء مسقط والخوض — خبراؤنا يخصصون كل علاج وفق نوع شعرك وأسلوب حياتك.
            </p>

            <div className="grid grid-cols-3 gap-4 mb-10">
              {[
                { icon: "ri-sparkling-2-line", en: "Frizz Control", ar: "تحكم في التجعد" },
                { icon: "ri-drop-line", en: "Deep Hydration", ar: "ترطيب عميق" },
                { icon: "ri-sun-line", en: "Lasting Shine", ar: "لمعان دائم" },
              ].map((f) => (
                <div key={f.en} className="text-center border border-[#ece8e0] py-4 px-2">
                  <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                    <i className={`${f.icon} text-[#c6a864] text-xl`}></i>
                  </div>
                  <p className="text-[#1a2744] text-xs uppercase font-light tracking-wide">{f.en}</p>
                  <p className="text-[#1a2744]/70 text-xs mt-0.5 font-medium" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>{f.ar}</p>
                </div>
              ))}
            </div>

            <a
              href="https://api.whatsapp.com/send?phone=96892102051&text=Hello%20Blue%20Moon%20Beauty%20Salon%20%26%20Spa%2C%20I%20would%20like%20more%20information%20about%20your%20services."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 whitespace-nowrap cursor-pointer border border-[#1a2744] text-[#1a2744] text-xs tracking-[0.2em] uppercase px-8 py-4 hover:bg-[#1a2744] hover:text-white transition-colors duration-300"
            >
              <i className="ri-whatsapp-line text-base"></i>
              <span>Book This Treatment</span>
              <span className="opacity-70" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>— احجزي العلاج</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
